import React from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';

/** "No closing date" — rolling admissions: the online form stays open until it is paused. */
const RollingAdmissionsSwitch: React.FC<{ checked: boolean; onChange: (rolling: boolean) => void; disabled?: boolean }> = ({ checked, onChange, disabled }) => (
  <FormControlLabel
    control={<Switch checked={checked} onChange={e => onChange(e.target.checked)} disabled={disabled} />}
    label={
      <Box>
        <Typography variant="body2" fontWeight={600}>No closing date</Typography>
        <Typography variant="caption" color="text.secondary">
          Rolling admissions — the online form stays open until you pause it from the cycle page.
        </Typography>
      </Box>
    }
    sx={{ alignItems: 'flex-start', ml: 0, gap: 1, '& .MuiSwitch-root': { mt: -0.5 } }}
  />
);

export default RollingAdmissionsSwitch;
